import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const AppIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>((props, forwardedRef) => {
  return (
    <IconWrapper {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M9 13C8.44772 13 8 13.4477 8 14V15C8 15.5523 8.44772 16 9 16H10C10.5523 16 11 15.5523 11 15V14C11 13.4477 10.5523 13 10 13H9zM13 14C13 13.4477 13.4477 13 14 13H15C15.5523 13 16 13.4477 16 14V15C16 15.5523 15.5523 16 15 16H14C13.4477 16 13 15.5523 13 15V14zM9 8C8.44772 8 8 8.44772 8 9V10C8 10.5523 8.44772 11 9 11H10C10.5523 11 11 10.5523 11 10V9C11 8.44772 10.5523 8 10 8H9zM13 9C13 8.44772 13.4477 8 14 8H15C15.5523 8 16 8.44772 16 9V10C16 10.5523 15.5523 11 15 11H14C13.4477 11 13 10.5523 13 10V9z"
          fill="#222"
        />
        <path
          d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6ZM18 6L6 6V18H18V6Z"
          fill="#222"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </svg>
    </IconWrapper>
  )
})
